import request from '@/utils/request'

/**
 * 获取日程列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getSchedules(params) {
  return request({
    url: '/schedules',
    method: 'get',
    params
  })
}

/**
 * 获取单个日程详情
 * @param {Number} scheduleId 日程 ID
 * @returns {Promise}
 */
export function getSchedule(scheduleId) {
  return request({
    url: `/schedules/${scheduleId}`,
    method: 'get'
  })
}

/**
 * 创建日程
 * @param {Object} data 日程数据
 * @returns {Promise}
 */
export function createSchedule(data) {
  return request({
    url: '/schedules',
    method: 'post',
    data
  })
}

/**
 * 更新日程
 * @param {Number} scheduleId 日程 ID
 * @param {Object} data 更新数据
 * @returns {Promise}
 */
export function updateSchedule(scheduleId, data) {
  return request({
    url: `/schedules/${scheduleId}`,
    method: 'put',
    data
  })
}

/**
 * 删除日程
 * @param {Number} scheduleId 日程 ID
 * @returns {Promise}
 */
export function deleteSchedule(scheduleId) {
  return request({
    url: `/schedules/${scheduleId}`,
    method: 'delete'
  })
}

/**
 * 获取指定 Session 下的所有日程
 * @param {Number} sessionId Session ID
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getSchedulesBySession(sessionId, params) {
  return request({
    url: `/sessions/${sessionId}/schedules`,
    method: 'get',
    params
  })
}
